import { type MouseEvent, useRef } from 'react';

/** Смещение курсора, после которого движение считается перетаскиванием, а не кликом, px */
const DRAG_THRESHOLD = 5;

/**
 * Прокрутка ленты перетаскиванием мышью, как лента миниатюр fotorama.
 * Клик после перетаскивания гасится, чтобы не выбирать фото
 */
export function useDragScroll() {
  const startRef = useRef<{ x: number; scrollLeft: number } | null>(null);
  const isDraggedRef = useRef(false);

  return {
    onMouseDown: (event: MouseEvent<HTMLElement>) => {
      startRef.current = { x: event.clientX, scrollLeft: event.currentTarget.scrollLeft };
      isDraggedRef.current = false;
    },
    onMouseMove: (event: MouseEvent<HTMLElement>) => {
      const start = startRef.current;

      if (!start) {
        return;
      }

      const deltaX = event.clientX - start.x;

      if (Math.abs(deltaX) >= DRAG_THRESHOLD) {
        isDraggedRef.current = true;
        event.currentTarget.scrollLeft = start.scrollLeft - deltaX;
      }
    },
    onMouseUp: () => {
      startRef.current = null;
    },
    onMouseLeave: () => {
      startRef.current = null;
    },
    onClickCapture: (event: MouseEvent) => {
      if (isDraggedRef.current) {
        isDraggedRef.current = false;
        event.stopPropagation();
        event.preventDefault();
      }
    },
    onDragStart: (event: MouseEvent) => event.preventDefault(),
  };
}
